import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { Queue } from '@uploadcare/upload-client';
export const blockCtx = () => ({
  /** @type {Set<import('./Block').Block>} */
  '*blocksRegistry': new Set(),
  /** @type {import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter | null} */
  '*eventEmitter': null
});

/** @param {import('./Block').Block} fnCtx */
export const activityBlockCtx = fnCtx => _objectSpread(_objectSpread({}, blockCtx()), {}, {
  '*currentActivity': '',
  '*currentActivityParams': {},
  '*history': [],
  '*historyBack': null,
  '*closeModal': () => {
    fnCtx.set$({
      '*modalActive': false,
      '*currentActivity': ''
    });
  }
});

/** @param {import('./Block').Block} fnCtx */
export const uploaderBlockCtx = fnCtx => _objectSpread(_objectSpread({}, activityBlockCtx(fnCtx)), {}, {
  '*commonProgress': 0,
  '*uploadList': [],
  '*focusedEntry': null,
  '*uploadMetadata': null,
  '*uploadQueue': new Queue(1),
  '*uploadCollection': null,
  /** @type {ReturnType<import('../utils/buildOutputError.js').buildCollectionFileError>[]} */
  '*collectionErrors': [],
  /** @type {import('../types').OutputCollectionState | null} */
  '*collectionState': null,
  /** @type {import('@uploadcare/upload-client').UploadcareGroup | null} */
  '*groupInfo': null,
  /** @type {Set<string>} */
  '*uploadTrigger': new Set()
});